// import React, { useState } from "react";

// function FontSizeChanger() {
//   // Define state to store affected elements and their original sizes
//   const [affectedElements, setAffectedElements] = useState([]);

//   // Function to store original sizes in state
//   const storeOriginalSizes = () => {
//     const elements = document.querySelectorAll("p, h1, h2, h3, h4, h5, h6");
//     const elementsArray = Array.from(elements).map((element) => ({
//       element,
//       origSize: window.getComputedStyle(element).fontSize,
//     }));
//     setAffectedElements(elementsArray);
//   };

//   // Function to change font size
//   const changeFontSize = (direction) => {
//     setAffectedElements((prevElements) => {
//       return prevElements.map(({ element, origSize }) => {
//         const currentSize = parseInt(window.getComputedStyle(element).fontSize);
//         const newSize = currentSize + direction;
//         element.style.fontSize = newSize + "px";
//         return { element, origSize };
//       });
//     });
//   };

//   // Function to reset font size to original
//   const resetFontSize = () => {
//     affectedElements.forEach(({ element, origSize }) => {
//       element.style.fontSize = origSize;
//     });
//   };

//   return (
//     <div>
//       <ul
//         className="fsize_control"
//         style={{
//           marginRight: "10px",
//           borderColor: "transparent",
//         }}
//       >
//         <button onClick={storeOriginalSizes}>Store Original Sizes</button>
//         Text Size:
//         <button
//           onClick={() => changeFontSize(-1)}
//           style={{ borderColor: "transparent", backgroundColor: "#6ea12f" }}
//         >
//           -A
//         </button>
//         <button
//           onClick={resetFontSize}
//           style={{ borderColor: "transparent", backgroundColor: "#6ea12f" }}
//         >
//           A
//         </button>
//         <button
//           onClick={() => changeFontSize(1)}
//           style={{ borderColor: "transparent", backgroundColor: "#6ea12f" }}
//         >
//           +A
//         </button>
//       </ul>

//       <div>
//         {affectedElements.map(({ element }, index) => (
//           <p key={index}>{element.tagName}</p>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default FontSizeChanger;
import React from "react";

function FontSizeChanger() {
  // Function to change font size
  const changeFontSize = (direction) => {
    const elements = document.querySelectorAll(
      "p, h1, h2, h3, h4, h5, h6, ul, li, button, a"
    );
    elements.forEach((element) => {
      const currentSize = parseFloat(window.getComputedStyle(element).fontSize);
      const newSize = currentSize + direction;
      element.style.fontSize = newSize + "px";
    });
  };

  // Function to reset font size to original
  const resetFontSize = () => {
    const elements = document.querySelectorAll(
      "p, h1, h2, h3, h4, h5, h6, ul, li, button, a"
    );
    elements.forEach((element) => {
      element.style.fontSize = ""; // Reset to default size (inherit from CSS)
    });
  };

  return (
    <div>
      <ul
        className="fsize_control"
        style={{
          marginRight: "10px",
          borderColor: "transparent",
        }}
      >
        Text Size:
        <button
          onClick={() => changeFontSize(-1)}
          style={{ borderColor: "transparent", backgroundColor: "#6ea12f" }}
        >
          A-
        </button>
        <button
          onClick={resetFontSize}
          style={{ borderColor: "transparent", backgroundColor: "#6ea12f" }}
        >
          A
        </button>
        <button
          onClick={() => changeFontSize(1)}
          style={{ borderColor: "transparent", backgroundColor: "#6ea12f" }}
        >
          A+
        </button>
      </ul>
    </div>
  );
}

export default FontSizeChanger;

// import React, { useState } from "react";

// function TextSizeControls() {
//   const [fontSize, setFontSize] = useState(16); // Initial font size

//   // Function to increase or decrease font size
//   const changeFontSize = (change) => {
//     setFontSize((prevFontSize) => prevFontSize + change);
//   };

//   return (
//     <ul className="fsize_control">
//       Text Size:
//       <button onClick={() => changeFontSize(-1)}>A-</button>
//       &nbsp;&nbsp;
//       <span style={{ fontSize: `${fontSize}px` }}>A</span>
//       &nbsp;&nbsp;
//       <button onClick={() => changeFontSize(1)}>A+</button>
//     </ul>
//   );
// }

// export default TextSizeControls;

// // FontSizeContext.js
// // import React, { createContext, useContext, useState } from "react";

// // const FontSizeContext = createContext();

// // export const useFontSize = () => {
// //   return useContext(FontSizeContext);
// // };

// // export const FontSizeProvider = ({ children }) => {
// //   const [fontSize, setFontSize] = useState(16); // Initial font size

// //   const changeFontSize = (change) => {
// //     setFontSize((prevFontSize) => prevFontSize + change);
// //   };

// //   return (
// //     <FontSizeContext.Provider value={{ fontSize, changeFontSize }}>
// //       {children}
// //     </FontSizeContext.Provider>
// //   );
// // };
